import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'selectAll', 'count', 'actions', 'form', 'selectedIds']

  connect() {
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  updateUI() {
    const checkedCount = this.checkedBoxes.length
    const totalCount = this.checkboxTargets.length

    // Update count display
    if (this.hasCountTarget) {
      this.countTarget.textContent = checkedCount
    }

    // Show/hide actions based on selection
    if (this.hasActionsTarget) {
      if (checkedCount > 0) {
        this.actionsTarget.classList.remove('hidden')
      } else {
        this.actionsTarget.classList.add('hidden')
      }
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checkedCount === totalCount && totalCount > 0
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }
  }

  submitSelected(event) {
    event.preventDefault()
    const ids = this.selectedIds

    if (ids.length === 0) {
      alert('Please select at least one item.')
      return
    }

    // Get the URL from the form or button
    const url = event.currentTarget.dataset.url || event.currentTarget.href
    const separator = url.includes('?') ? '&' : '?'

    // Navigate to the URL with selected IDs
    window.open(`${url}${separator}bin_ids=${ids.join(',')}`, '_blank')
  }

  get checkedBoxes() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked)
  }

  get selectedIds() {
    return this.checkedBoxes.map(checkbox => checkbox.value)
  }
}
